import Model from '@/app/Model'

export class Manufacturer extends Model {
	static fields () {
		return {
			name: null,
			id: null
		}
	}
	static hasMany () {
		return {
			//
		}
	}
}

export function createManufacturer (data) {
	return Object.freeze(new Manufacturer(data))
}
